import useQueryUserTier from '@/hooks/query/useQueryUserTier';
import { GET_TEAM_MEMBERS_WITH_RELATIONSHIP } from '@heidi/workspace/contracts';
import { useQueryTeamMembersWithRelationshipCore } from '@heidi/workspace/data';

export { GET_TEAM_MEMBERS_WITH_RELATIONSHIP };

export function useQueryTeamMembersWithRelationship(teamId?: string) {
  const { userTier, isTogetherOrHigherTier } = useQueryUserTier();

  return useQueryTeamMembersWithRelationshipCore(
    teamId,
    !!userTier && isTogetherOrHigherTier
  );
}
